/* global 'molecule' */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { componentClassNameProp } from 'common/src/app/util/componentClassNameUtils';

import TextNew, { Colors, ElementTypes, FontWeight } from '../../atoms/TextNew';
import './contact-us-success-message.scss';

class ContactUsSuccessMessage extends Component {
  componentDidMount() {
    const { scrollToElement, disableScrollTo = false } = this.props;

    !disableScrollTo && scrollToElement(this.successMessage, -70);
  }

  render() {
    const { showLongResponseMessage } = this.props;

    return (
      <div
        ref={el => (this.successMessage = el)}
        {...componentClassNameProp('molecule', this)}
      >
        <TextNew.Serif.LG
          localeId="contactUsSuccessMessage.header"
          element={ElementTypes.H3}
          color={Colors.BRAND}
        />
        <TextNew.Sans.SM
          localeId="contactUsSuccessMessage.success"
          weight={FontWeight.LIGHT}
          cid="success"
        />

        {showLongResponseMessage && (
          <TextNew.Sans.SM localeId="contactUsSuccessMessage.veryBusy" weight={FontWeight.LIGHT} />
        )}
      </div>
    );
  }
}

ContactUsSuccessMessage.propTypes = {
  disableScrollTo: PropTypes.bool,
  scrollToElement: PropTypes.func,
  subjectId: PropTypes.string,
  showLongResponseMessage: PropTypes.bool,
};

export default ContactUsSuccessMessage;
